import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, EmbeddedViewRef, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { Menu } from './menu.model';
import { verticalMenuItems, horizontalMenuItems } from './menu';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { VerticalMenuComponent } from './vertical-menu/vertical-menu.component';
import { AuthService } from '../../../shared/services/auth.service';
import { GeneralService } from '../../../shared/services/general.service';

@NgModule({
  providers: [GeneralService],
})

@Injectable()
export class MenuService {
  private readonly urlBase = '/api/';
  public static menuItems: Menu[];
  private static _totalRejected = new BehaviorSubject<number>(null);
  totalRejected$ = MenuService._totalRejected.asObservable();

  constructor(private location:Location,
              private router:Router,
              private http: HttpClient,
              private componentFactoryResolver: ComponentFactoryResolver,
                private applicationRef: ApplicationRef,
                private injector: Injector,
                private generalService: GeneralService
            ){ } 

  static get totalRejected(): number{
    return MenuService._totalRejected.getValue();
  }

  static set totalRejected(total: number){
    MenuService._totalRejected.next(total);
  }
    
  public getVerticalMenuItems():Array<Menu> {
    return verticalMenuItems;
  }

  public getHorizontalMenuItems():Array<Menu> {
    return horizontalMenuItems;
  }

  delete(id: number) {
    return this.http.post(this.urlBase + 'deleteMenu', {id: id, createdBy: AuthService.getUser().id});
  }

  getMenu(): Observable<Menu[]> {
    return this.http.get<Menu[]>(this.urlBase + 'getMenu');
  }

  save(menu): Observable<Menu> {
    return this.http.post<Menu>(this.urlBase + 'saveMenu', menu);
  }

  LoadDocumentationNotifications(business_id, registration){
    this.generalService.getDocumentationNotifications(business_id, registration).subscribe(result => {
      MenuService.totalRejected = result.info;
    });
  }

  public expandActiveSubMenu(menu:Array<Menu>){
      let url = this.location.path();
      let routerLink = url; // url.substring(1, url.length);
      let activeMenuItem = menu.filter(item => item.routerLink === routerLink);
      if(activeMenuItem[0]){
        let menuItem = activeMenuItem[0];
        while (menuItem.parentId != 0){  
          let parentMenuItem = menu.filter(item => item.id == menuItem.parentId)[0];
          menuItem = parentMenuItem;
          this.toggleMenuItem(menuItem.id);
        }
      }
  }

  public toggleMenuItem(menuId){
    let menuItem = document.getElementById('menu-item-'+menuId);
    let subMenu = document.getElementById('sub-menu-'+menuId);  
    if(subMenu){
      if(subMenu.classList.contains('show')){
        subMenu.classList.remove('show');
        menuItem.classList.remove('expanded');
      }
      else{
        subMenu.classList.add('show');
        menuItem.classList.add('expanded');
      }      
    }
  }

  public closeOtherSubMenus(menu:Array<Menu>, menuId){
    let currentMenuItem = menu.filter(item => item.id == menuId)[0]; 
    if(currentMenuItem.parentId == 0 && !currentMenuItem.target){
      menu.forEach(item => {
        if(item.id != menuId){
          let subMenu = document.getElementById('sub-menu-'+item.id);
          let menuItem = document.getElementById('menu-item-'+item.id);
          if(subMenu){
            if(subMenu.classList.contains('show')){
              subMenu.classList.remove('show');
              menuItem.classList.remove('expanded');
            }              
          } 
        }
      });
    }
  }

  addNewMenuItem(component: any, menuItems: Menu[], newMenuItem: Menu) {

    const i = menuItems.findIndex(item => item.id == newMenuItem.id);
    if(i) {
      MenuService.menuItems.splice(i, 1, newMenuItem);
    } else {
      // menuItems.push(newMenuItem);
      MenuService.menuItems.push(newMenuItem);
    }
    console.log(MenuService.menuItems);
            
    // let item = menuItems.filter(item=>item.id == newMenuItem.parentId)[0];
    // if(item) item.hasSubMenu = true;  

    const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);        
    
    this.applicationRef.attachView(componentRef.hostView);
    
    let instance = <VerticalMenuComponent>componentRef.instance;
    // instance.menuItems = menuItems;
    instance.menuParentId = 0;

    const elem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    
    const sidenav = document.getElementById('sidenav-menu-outer');        
    sidenav.replaceChild(elem, sidenav.children[0]);     
} 
  

}
